"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMappingHeaderUri = exports.getMappingHeaderIdentifier = exports.getMappingHeaderName = exports.getMappingHeaderLocalIdentifier = exports.hasMappingHeaderLocalIdentifier = void 0;
// (C) 2007-2020 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
//
//
//
/**
 * @internal
 */
function hasMappingHeaderLocalIdentifier(header) {
    return sdk_backend_spi_1.isAttributeDescriptor(header) || sdk_backend_spi_1.isMeasureDescriptor(header);
}
exports.hasMappingHeaderLocalIdentifier = hasMappingHeaderLocalIdentifier;
/**
 * @internal
 */
function getMappingHeaderLocalIdentifier(header) {
    if (sdk_backend_spi_1.isAttributeDescriptor(header)) {
        return header.attributeHeader.localIdentifier;
    }
    else if (sdk_backend_spi_1.isMeasureDescriptor(header)) {
        return header.measureHeaderItem.localIdentifier;
    }
    throw new Error("Mapping header of type \"" + Object.keys(header) + "\" has no localIdentifier");
}
exports.getMappingHeaderLocalIdentifier = getMappingHeaderLocalIdentifier;
/**
 * @internal
 */
function getMappingHeaderName(header) {
    if (sdk_backend_spi_1.isAttributeDescriptor(header)) {
        return header.attributeHeader.formOf.name;
    }
    else if (sdk_backend_spi_1.isResultAttributeHeader(header)) {
        return header.attributeHeaderItem.name;
    }
    else if (sdk_backend_spi_1.isMeasureDescriptor(header)) {
        return header.measureHeaderItem.name;
    }
}
exports.getMappingHeaderName = getMappingHeaderName;
/**
 * @internal
 */
function getMappingHeaderIdentifier(header) {
    if (sdk_backend_spi_1.isAttributeDescriptor(header)) {
        return header.attributeHeader.identifier;
    }
    else if (sdk_backend_spi_1.isMeasureDescriptor(header)) {
        return header.measureHeaderItem.identifier;
    }
    throw new Error("Mapping header of type \"" + Object.keys(header) + "\" has no identifier");
}
exports.getMappingHeaderIdentifier = getMappingHeaderIdentifier;
/**
 * @internal
 */
function getMappingHeaderUri(header) {
    if (sdk_backend_spi_1.isAttributeDescriptor(header)) {
        return header.attributeHeader.uri;
    }
    else if (sdk_backend_spi_1.isResultAttributeHeader(header)) {
        return header.attributeHeaderItem.uri;
    }
    else if (sdk_backend_spi_1.isMeasureDescriptor(header)) {
        return header.measureHeaderItem.uri;
    }
}
exports.getMappingHeaderUri = getMappingHeaderUri;
//# sourceMappingURL=MappingHeader.js.map